import { FC, useState } from 'react';
import clsx from 'clsx';

import SvgRender from '@/library/components/general/SvgRender';

type ButtonProps = {
  src: string;
  label: string;
  backgroundColor: string;
  hoverBackgroundColor: string;
  color: string;
  iconSize: number;
  onClick: () => void;
  disabled?: boolean;
};

const Button: FC<ButtonProps> = ({
  src,
  label,
  backgroundColor,
  hoverBackgroundColor,
  color,
  iconSize,
  onClick,
  disabled
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      type="button"
      disabled={disabled}
      className={clsx(
        'd-flex align-items-center justify-content-center border-0 border-radius-3 user-select-none px-2 py-1',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        `bg-${!disabled && isHovered ? hoverBackgroundColor : backgroundColor}`,
        `text-${color}`
      )}
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <SvgRender src={src} style={{ width: iconSize, height: iconSize }} />
      <span className="fw-medium fs-14 ms-1">{label}</span>
    </button>
  );
};

export default Button;
